module.exports = __webpack_public_path__ + "img/header.a937779a.png";